import React from "react";
import { trackEvent } from "../utils/analytics";

const Footer = () => {
  const sitemap = [
    {
      label: "Home",
      href: "#home",
    },
    {
      label: "About",
      href: "#about",
    },
    {
      label: "Project",
      href: "#projects",
    },
    {
      label: "Contact me",
      href: "#contact",
    },
  ];

  const socials = [
    {
      label: "GitHub",
      href: "https://github.com/perkypearl",
    },
    {
      label: "LinkedIn",
      href: "https://www.linkedin.com/in/perkypearl",
    },
    {
      label: "Twitter X",
      href: "https://x.com/precise_pearl",
    },
    {
      label: "Instagram",
      href: "https://www.instagram.com/precisepearl/",
    },
  ];
  
  return (
    <footer className="section">
      <div className="container">
        {/* <div className="lg:grid lg:grid-cols-2">
          <div className="mb-10">
            <h2 className="headline-1  mb-8 lg:max-w-[12ch] ">
              Let's Work Together!
            </h2>

            <ButtonPrimary
              href="mailto:perkypearl.dev@gmail.com"
              label="Start Project"
              icon="chevron_right"
              classes=""
            />
          </div>
        </div> */}

        <div className="grid grid-cols-2 gap-4 lg:pl-20">
          <div>
            <p className="mb-2 ">Sitemap</p>

            <ul>
              {sitemap.map(({ label, href }, key) => (
                <li key={key}>
                  <a
                    href={href}
                    className="block text-sm text-zinc-400 py-1 transition-colors hover:text-zinc-200 "
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="mb-2 ">Socials</p>

            <ul>
              {socials.map(({ label, href }, key) => (
                <li key={key}>
                  <a
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block text-sm text-zinc-400 py-1 transition-colors hover:text-zinc-200"
                    onClick={() => trackEvent("github_profile_click", { link_url: href, link_type: "social" })}
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex items-center justify-center py-5 mb-8">
          <p className="text-zinc-500 text-sm ">
            &copy; 2026 <span className="text-zinc-200">perkyPearl</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;